import React from "react";
import { IResourceComponentsProps, HttpError } from "@refinedev/core";
import { Edit, useForm } from "@refinedev/mantine";
import { TextInput, NumberInput, Select, Switch } from "@mantine/core";
import { isNotEmpty } from "@mantine/form";
import { OfferConfiguration } from "entities/cancel_flow";
import { selectBrands } from "entities/cancel_flow/brand";
import { selectSegments } from "entities/cancel_flow/segment";
import { selectOfferTypes } from "entities/cancel_flow/offerType";
import useCancelFlowPermissions from "./useCancelFlowPermissions";
import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

export const OfferConfigurationEdit: React.FC<IResourceComponentsProps> = () => {
  const { canEdit } = useCancelFlowPermissions();

  const { getInputProps, saveButtonProps } = useForm<
    OfferConfiguration,
    HttpError,
    OfferConfiguration
  >({
    initialValues: {
      id: 0,
      brand: "tokyotreat" as OfferConfiguration["brand"],
      segment: "monthly_3mo" as OfferConfiguration["segment"],
      offer_type: "discount" as OfferConfiguration["offer_type"],
      offer_value: "",
      chargebee_coupon_id: "",
      weight: 50,
      is_active: true,
      created_at: "",
      updated_at: "",
    },
    validateInputOnBlur: true,
    validate: {
      brand: isNotEmpty("Brand is required"),
      segment: isNotEmpty("Segment is required"),
      offer_type: isNotEmpty("Offer type is required"),
      offer_value: isNotEmpty("Offer value is required"),
    },
  });

  if (!canEdit) {
    return (
      <Alert icon={<IconAlertCircle size={16} />} title="Permission Denied">
        You are not allowed to update this resource.
      </Alert>
    );
  }

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Select
        label="Brand"
        data={selectBrands}
        withAsterisk
        {...getInputProps("brand")}
      />
      <Select
        mt="sm"
        label="Segment"
        data={selectSegments}
        withAsterisk
        {...getInputProps("segment")}
      />
      <Select
        mt="sm"
        label="Offer Type"
        data={selectOfferTypes}
        withAsterisk
        {...getInputProps("offer_type")}
      />
      <TextInput
        mt="sm"
        label="Offer Value"
        withAsterisk
        {...getInputProps("offer_value")}
      />
      <TextInput
        mt="sm"
        label="Chargebee Coupon ID"
        {...getInputProps("chargebee_coupon_id")}
      />
      <NumberInput
        mt="sm"
        label="Weight"
        {...getInputProps("weight")}
      />
      <Switch
        mt="sm"
        label="Active"
        {...getInputProps("is_active", { type: "checkbox" })}
      />
    </Edit>
  );
};
